// @flow strict

import * as React from 'react'

import DesktopPricingTable from './DesktopPricingTable'
import MobilePricingTable from './MobilePricingTable'

import styles from './PricingTable.module.scss'

export const CheckMark = () => (
  <svg width="20" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.76 7.35a1 1 0 10-1.52 1.3l6 7a1 1 0 001.52 0l12-14a1 1 0 10-1.52-1.3L7 13.462 1.76 7.35z"
      fill="#14233C"
      fillRule="evenodd"
      opacity=".8"
    />
  </svg>
)

export const Cross = () => (
  <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M.293.293a1 1 0 011.414 0L7 5.585 12.293.293a1 1 0 011.32-.083l.094.083a1 1 0 010 1.414L8.415 7l5.292 5.293a1 1 0 01.083 1.32l-.083.094a1 1 0 01-1.414 0L7 8.415l-5.293 5.292a1 1 0 01-1.32.083l-.094-.083a1 1 0 010-1.414L5.585 7 .293 1.707A1 1 0 01.21.387z"
      fill="#C8C7CC"
      fillRule="evenodd"
      opacity=".8"
    />
  </svg>
)

type Feature = {|
  icon: string,
  title: string,
  description: string,
  tooltipLinkText?: string,
  tooltipLink?: string,
  plans: string[],
|}

export type PricingTableProps = {|
  featureGroups: Array<{
    title: string,
    features: Array<Feature>,
  }>,
  plans: Array<{|
    id: string,
    name: string,
    tagline: string,
    pricePerMonthInPence: number,
  |}>,
  title?: string,
  footer?: string,
  signupLink: string,
|}

export const PricingTable = ({
  featureGroups,
  plans,
  title,
  footer,
  signupLink,
}: PricingTableProps) => {
  if (plans == null || title == null || featureGroups == null) {
    return null
  }
  return (
    <div className={styles.baseContent}>
      <DesktopPricingTable
        featureGroups={featureGroups}
        plans={plans}
        title={title}
        signupLink={signupLink}
      />
      <MobilePricingTable
        featureGroups={featureGroups}
        plans={plans}
        title={title}
        signupLink={signupLink}
      />
      {footer && <p className={styles.footer}>{footer}</p>}
    </div>
  )
}

export default PricingTable
